export default __webpack_public_path__ + "static/assets/3cbbce5839962de901c179b12e981ddb.gif";